import HeroResponsiveCarousel from "../HeroResponsiveCarousel";

class PageConnect {
    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        const heroEl = this.el.querySelector('.connect-carousel');
        if (heroEl) {
            const carousel = new HeroResponsiveCarousel(heroEl);
        }
    }
}

export default PageConnect;
